<template>
  <div class="min-h-screen flex flex-col bg-[#1b006e]">
    <HeaderLogin />
    <div class="px-4 pt-12 pb-4">
      <BtnBack />
    </div>

    <div class="flex-grow px-4">
      <div class="mx-auto w-full max-w-[400px]">
        <!-- 🔥 หัวเรื่อง -->
        <div class="flex justify-between items-end w-full mb-4">
          <h4 class="text-lg text-white font-bold flex items-end">
            <img src="/assets/icons/fire.gif" alt="fire icon" class="w-10 h-10 flex-shrink-0 self-end mr-2" />
            หมุนรางวัลสุ่ม
          </h4>
          <button @click="goToHistory" class="text-white text-xs font-bold flex items-center hover:underline ml-auto">
            <span class="material-icons mr-1 flex-shrink-0">history</span>
            ประวัติหมุนรางวัลสุ่ม
          </button>
        </div>

        <!-- 🎁 Grid 3x3 -->
        <div class="grid grid-cols-3 gap-2 bg-[#1b006e] rounded-xl p-3 shadow-lg w-[350px] h-[340px] mx-auto">
          <div v-for="(reward, index) in displayRewards" :key="index"
            class="flex flex-col items-center justify-center bg-gradient-to-br rounded-lg text-center p-2 text-sm font-medium transition-all duration-200"
            :class="{ 'animate-ping-fast': spinningIndex === index }">
            <img :src="getImageForReward(reward)" class="w-16 h-16 mb-1 object-contain" />
            <span class="text-xs text-white">{{ reward.name }}</span>
          </div>
        </div>

        <!-- 🎯 ปุ่มหมุน -->
        <div class="mt-6 flex justify-center">
          <button @click="spin" :disabled="isSpinning"
            class="bg-blue-600 text-white text-sm px-6 py-2 rounded-full shadow-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
            🎯 เริ่มหมุน
          </button>
        </div>

        <!-- 🎉 ผลลัพธ์ -->
        <div class="mt-4 text-white text-lg text-center" v-if="selectedReward && !isSpinning">
          🎉 คุณได้: <strong>{{ selectedReward.name }}</strong>
        </div>
      </div>
    </div>

    <!-- ✅ Modal ประวัติการหมุน -->
    <div v-if="showHistoryModal" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div class="bg-white text-black p-4 rounded-xl w-[90%] max-w-md max-h-[80vh] overflow-y-auto">
        <h3 class="text-lg font-bold mb-3">🎁 ประวัติการหมุนรางวัล</h3>

        <ul class="space-y-2">
          <li v-for="(item, index) in historyList" :key="index" class="border-b pb-1">
            <div class="flex justify-between items-center">
              <span>{{ item.reward?.name || "-" }}</span>
              <span class="text-xs text-gray-500">{{ formatDate(item.date) }}</span>
            </div>
          </li>
        </ul>

        <div class="mt-4 text-right">
          <button @click="showHistoryModal = false" class="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600">
            ปิด
          </button>
        </div>
      </div>
    </div>


    <!-- ✅ Toast Notification -->
    <div v-if="toastMessage" class="fixed bottom-4 right-4 bg-green-500 text-white p-4 rounded shadow-lg z-50">
      {{ toastMessage }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/config/apiPath";
import HeaderLogin from "@/components/HeaderLogin.vue";
import BtnBack from "@/components/BtnBack.vue";

export default {
  name: "CreditLucky",
  components: { HeaderLogin, BtnBack },
  data() {
    return {
      rewards: [],
      selectedReward: null,
      toastMessage: "",
      showHistoryModal: false,
      fallbackImages: {
        money: require("@/assets/icons/bet-icon.png"),
        gold: require("@/assets/icons/Gold.gif"),
        none: require("@/assets/icons/error.gif"),
      },
      isSpinning: false,
      spinningIndex: null,
    };
  },
  computed: {
    displayRewards() {
      const rewardItems = [...this.rewards];
      while (rewardItems.length < 9) {
        rewardItems.push({ name: "?", image: this.fallbackImages.money });
      }
      return rewardItems.slice(0, 9);
    },
  },
  methods: {
    getImageForReward(reward) {
      if (reward?.image) return reward.image;
      const name = reward?.name || "";
      if (name.includes("ทอง")) return this.fallbackImages.gold;
      if (name.includes("ไม่ได้")) return this.fallbackImages.none;
      return this.fallbackImages.money;
    },
    showToast(message, duration = 2500) {
      this.toastMessage = message;
      setTimeout(() => {
        this.toastMessage = "";
      }, duration);
    },
    async fetchRewards() {
      try {
        const res = await axios.get(api.GET_CREDIT_REWARDS);
        this.rewards = res.data;
      } catch {
        this.showToast("โหลดรางวัลไม่สำเร็จ");
      }
    },
    async spin() {
      const vuexStore = localStorage.getItem("vuex");
      const parsed = vuexStore ? JSON.parse(vuexStore) : null;
      const userId = parsed?.user?.userId;

      if (!userId) {
        return this.showToast("ไม่พบข้อมูลผู้ใช้ในระบบ");
      }

      this.isSpinning = true;
      this.selectedReward = null;

      // 💫 แสดงแอนิเมชันหมุนรางวัล
      let i = 0;
      const spinInterval = setInterval(() => {
        this.spinningIndex = i % 9;
        i++;
      }, 100);

      // 🕐 หมุน 5 วินาทีแล้วค่อยแสดงผลจริง
      setTimeout(async () => {
        clearInterval(spinInterval);
        this.spinningIndex = null;

        try {
          const res = await axios.post(api.SPIN_REWARD, { userId });
          this.selectedReward = res.data.reward;
          this.showToast(`🎉 คุณได้รับรางวัล: ${res.data.reward.name}`);
        } catch (err) {
          const msg = err.response?.data?.message;

          // 🔁 แปลงข้อความระบบให้เป็นภาษาไทย
          if (msg === "Spin limit reached for today") {
            this.showToast("คุณหมุนครบจำนวนที่กำหนดสำหรับวันนี้แล้ว");
          } else if (msg === "User not found") {
            this.showToast("ไม่พบข้อมูลผู้ใช้ในระบบ");
          } else if (msg === "Not enough points") {
            this.showToast("คุณมีคะแนนไม่เพียงพอในการหมุน");
          } else {
            this.showToast("เกิดข้อผิดพลาดขณะหมุนรางวัล");
          }
        } finally {
          this.isSpinning = false;
        }
      }, 5000);
    },
    async goToHistory() {
      try {
        const vuexStore = localStorage.getItem("vuex");
        const parsed = vuexStore ? JSON.parse(vuexStore) : null;
        const userId = parsed?.user?.userId;

        if (!userId) {
          return this.showToast("ไม่พบข้อมูลผู้ใช้");
        }

        const res = await axios.get(api.GET_SPIN_HISTORY(userId));
        this.historyList = res.data.spinHistory || [];
        this.showHistoryModal = true;
      } catch (err) {
        this.showToast("ไม่สามารถโหลดประวัติการหมุนได้");
      }
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
  },
  mounted() {
    this.fetchRewards();
  },
};
</script>

<style scoped>
.bg-gradient-to-br {
  background: linear-gradient(135deg, #172f82, #180650);
  border: 1px solid #EECE61;
}

@keyframes ping-fast {

  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.5;
  }
}

.animate-ping-fast {
  animation: ping-fast 0.3s ease-in-out infinite;
}
</style>
